import classNames from "classnames";
import { ReactNodeArray } from "react";

import "./Table.css";

type TableProps = {
  getTableProps?: Function;
  getTableBodyProps?: Function;
  headerGroups: ReactNodeArray;
  rows: ReactNodeArray;
  className?: string;
};

const Table = ({
  getTableProps,
  getTableBodyProps,
  headerGroups,
  rows,
  className,
}: TableProps) => {
  return (
    <table
      className={classNames("PWTable", className)}
      {...(getTableProps && getTableProps())}
    >
      <thead>{headerGroups}</thead>
      <tbody {...(getTableBodyProps && getTableBodyProps())}>{rows}</tbody>
    </table>
  );
};

export default Table;
